import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import Starfield from "@/components/Starfield";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("This login is for admins only.");
        return;
      }
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatDetail(err?.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="relative min-h-screen grid place-items-center bg-void overflow-hidden" data-testid="admin-login">
      <Starfield count={60} />
      <motion.form
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.8, 0, 0.2, 1] }}
        onSubmit={onSubmit}
        className="relative z-10 w-[92vw] max-w-md rounded-3xl gradient-border bg-[#141323] p-8 md:p-10"
      >
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.svg" alt="CaarSaarthi" className="w-8 h-8 rounded-full" />
          <span className="font-serif text-2xl text-white tracking-tight">CaarSaarthi</span>
        </Link>
        <h1 className="mt-8 font-serif text-4xl md:text-5xl text-white leading-tight">
          Admin <span className="italic gradient-text">Console</span>
        </h1>
        <p className="mt-3 text-sm text-silver/60">Buyer-side leads. Zero dealer eyes.</p>

        <label className="block eyebrow gradient-text mt-8">Email</label>
        <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="admin@caarsaarthi.com" className="mt-3 h-12 bg-void border-white/10 text-white" data-testid="admin-email-input" />
        <label className="block eyebrow gradient-text mt-6">Password</label>
        <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="••••••••" className="mt-3 h-12 bg-void border-white/10 text-white" data-testid="admin-password-input" />

        <button
          type="submit"
          disabled={loading}
          className="mt-8 w-full py-3.5 rounded-full font-medium text-white gradient-bg disabled:opacity-60 hover:scale-[1.01] transition-transform"
          data-testid="admin-login-submit"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <Link to="/" className="mt-6 block text-center text-xs text-silver/50 hover:text-silver">← Back to site</Link>
      </motion.form>
    </main>
  );
}
